// Mantén tus slugs opacos tal cual
import { ROLES } from "../auth/roles";
import { HomeIcon, Users, Repeat, Phone } from "lucide-react";

import DashboardPrincipalAdmin from "../layouts/admin/DashboardPrincipalAdmin";
import DashboardUsersAdmin from "../layouts/admin/DashboardUsersAdmin";
import DashboardClientesAdmin from "../layouts/admin/DashboardCompaniesAdmin";
import DashboardPadlockIdAdmin from "../layouts/admin/DashboardPadlockIdAdmin";
import LockAdmin from "../layouts/admin/DashboardLockAdmin";
import CreateLock from "../layouts/admin/create/CreateLock";
import CreateUserAdmin from "../layouts/admin/create/CreateUserAdmin";
import UserEditAdmin from "../layouts/admin/edit/UserEditAdmin";
import PadlockEditAdmin from "../layouts/admin/edit/PadlockEditAdmin";
import CreateCompanies from "../layouts/admin/create/CreateCompanies";
import DashboardCompaniesId from "../layouts/admin/DasboardCompaniesId";
import CompaniesEdit from "../layouts/admin/edit/CompaniesEdit";


export const adminRoutes = [
  { path: "/admin", element: <DashboardPrincipalAdmin/>, roles:[ROLES.ADMIN], label:"Inicio", icon:<HomeIcon size={18}/>, menu:true },

  { path: "/dashboardusersadmin", element: <DashboardUsersAdmin/>, roles:[ROLES.ADMIN], label:"Usuarios", icon:<Users size={18}/>, menu:true },
  { path: "/dashboardclientesadmin", element: <DashboardClientesAdmin/>, roles:[ROLES.ADMIN], label:"Clientes", icon:<Repeat size={18}/>, menu:true },
  { path: "/locksadmin", element: <LockAdmin/>, roles:[ROLES.ADMIN], label:"Candados", icon:<Phone size={18}/>, menu:true },

  // FUERA DEL MENU
  
  // USUARIOS
  { path: "/createuseradmin", element: <CreateUserAdmin/>, roles:[ROLES.ADMIN] },
  { path: "/usersadmin/:id/edit", element: <UserEditAdmin/>, roles:[ROLES.ADMIN] },
  
  // CANDADOS
  { path: "/locksadmin/create", element: <CreateLock/>, roles:[ROLES.ADMIN] },
  { path: "/locksadmin/:serialNumber", element: <DashboardPadlockIdAdmin/>, roles:[ROLES.ADMIN] },
  { path: "/locksadmin/:serialNumber/edit", element: <PadlockEditAdmin />, roles:[ROLES.ADMIN] },

  // COMPAÑIAS
  { path: "/companies/create", element: <CreateCompanies/>, roles:[ROLES.ADMIN] },
  { path: "/companies/:id", element: <DashboardCompaniesId/>, roles:["ADMIN"] },
  { path: "/companies/:id/edit", element: <CompaniesEdit/>, roles:["ADMIN"] },

];
